import { DotIndicator } from '../DotIndicator';
import { DotIndicatorProps } from '../DotIndicator/DotIndicator';

export type RiskLevel = 'LOW' | 'MEDIUM' | 'HIGH' | 'UNKNOWN';

const RISK_DOT_PROPS: Record<RiskLevel, DotIndicatorProps> = {
  LOW: { color: 'success' },
  MEDIUM: { color: 'warning' },
  HIGH: { color: 'error' },
  UNKNOWN: { outlined: true, color: 'grey' },
};
/**
 * Traffic light indicator for risk level highlight in chat
 * (used Dot from FinancialInfo component for consistency in design)
 *
 * @param riskLevel - The risk level to indicate (LOW, MEDIUM, HIGH, UNKNOWN)
 * @returns A colored dot representing the risk level
 */
export const RiskIndicator = ({ riskLevel }: { riskLevel: RiskLevel }) => {
  const { color, outlined } = RISK_DOT_PROPS[riskLevel] ?? RISK_DOT_PROPS['UNKNOWN'];
  return <DotIndicator color={color} outlined={outlined} />;
};
